export default __webpack_public_path__ + "static/2-e320e47499ef1b964d914805406256ce.png";